import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { IDLE, PENDING } from "const"
import { StateType } from "client/utils"
import {
    StoreType,
    CcRequirementReviewProps,

    LoadProjectByIdOnly,
    LoadCcRequirementTypes,
    LoadCcRequirementPriorities,
    LoadCcRequirementStatuses,
    LoadCcApprovalLevels,
    LoadCcResponses,
    LoadCcRequirementById,
    LoadCcRequirementHistory,

    setCcRequirementTypeList,
    setCcRequirementPriorityList,
    setCcRequirementStatusList,
    setCcApprovalLevelList,
    setCcResponseList,
    setCcModuleResponseList,
    setCcRequirementRequirementDetails,
    setCcRequirementRequirementHistory,
} from "client/store"
import {
    Container,
    PageHeader,
    PageTitle,
    PageContent,
    Loader,
} from "client/components"

import NotFound from "client/parts/notFound"
import Details from "./details"
import History from "./history"

interface RequirementAnswerProps extends CcRequirementReviewProps {
    projectId: number
}

const RequirementAnswer = ({
    projectId,
    requirementId,
    revisionId,
}: RequirementAnswerProps) => {
    const requirement = useSelector((state: StoreType) => state.ccRequirement.requirementDetails)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [loadState, setLoadState] = useState<StateType>(IDLE)

    useEffect(() => {
        setLoadState(PENDING)
        Promise.all([
            LoadProjectByIdOnly(projectId).then((project) => (
                Promise.all([
                    LoadCcRequirementTypes(project.accountId, project.id).then((res) => {
                        dispatch(setCcRequirementTypeList(res))
                    }),
                    LoadCcRequirementPriorities(project.accountId, project.id).then((res) => {
                        dispatch(setCcRequirementPriorityList(res.priorityList))
                    }),
                    LoadCcRequirementStatuses(project.accountId, project.id).then((res) => {
                        dispatch(setCcRequirementStatusList(res.statusList))
                    }),

                    // requirement approval levels
                    LoadCcApprovalLevels(project.accountId, project.id, 3)
                    .then((res) => {
                        dispatch(setCcApprovalLevelList(res.levelList))
                    }),
                    // requirement responses
                    LoadCcResponses(project.accountId, project.id, 4)
                    .then((res) => {
                        dispatch(setCcResponseList(res.responseList))
                        dispatch(setCcModuleResponseList({ 4: res.responseIds }))
                    }),
                    // responsible responses
                    LoadCcResponses(project.accountId, project.id, 0)
                    .then((res) => {
                        dispatch(setCcResponseList(res.responseList))
                        dispatch(setCcModuleResponseList({ 0: res.responseIds }))
                    }),
                ])
            )),
            LoadCcRequirementById(requirementId, projectId).then((res) => {
                dispatch(setCcRequirementRequirementDetails(res))
            }),
            LoadCcRequirementHistory(requirementId, revisionId).then((res) => {
                dispatch(setCcRequirementRequirementHistory(res))
            }),
        ]).then(() => {
            setLoadState(IDLE)
        })
    }, [])

    if (!requirement) return <NotFound />
    return (
        <Container>
            <PageHeader>
                <PageTitle>{lang.editAnswer}</PageTitle>
            </PageHeader>
            <PageContent>
                {
                    loadState === PENDING
                    && <Loader />
                }

                <Details />
                <History />
            </PageContent>
        </Container>
    )
}
export default RequirementAnswer
